import {
  DocumentClauseAPIModel,
  DocumentFieldAPIModel,
} from '~/api/def/endpoints/document';
import { DocumentPDFField, PDFClause } from './types';

export function APIClauseToPDFClause(
  clause: DocumentClauseAPIModel,
): PDFClause {
  return {
    clauseId: clause.id,
    summary: clause.summary,
    title: clause.name,
    fullText: clause.fullText,
    sourceBoundingBox: {
      x1: clause.startXCoordinate,
      x2: clause.endXCoordinate,
      y1: clause.startYCoordinate,
      y2: clause.endYCoordinate,
      pageEnd: clause.endPageNo,
      pageStart: clause.startPageNo,
    },
  };
}

export function APIFieldToPDFField(
  field: DocumentFieldAPIModel,
): DocumentPDFField {
  if (!field.endXCoordinate || !field.endYCoordinate) {
    return {
      fieldId: field.id,
      field: field.name,
      value: field.value,
    };
  }
  return {
    fieldId: field.id,
    field: field.name,
    value: field.value,
    sourceBoundingBox: {
      x1: field.startXCoordinate as number,
      x2: field.endXCoordinate,
      y1: field.startYCoordinate as number,
      y2: field.endYCoordinate,
      pageEnd: field.endPageNo as number,
      pageStart: field.startPageNo as number,
    },
  };
}
